import countryList from "react-select-country-list";
import type { PickedRecord } from "./ClientRecordPicker";

const countries = countryList();

// CountryPicker ids are lowercase ISO alpha-2 ("us"). ConnectWise, and client
// locations adopted from it, hold the country name ("United States").
// Accepts an alpha-2 code or a name, case-insensitively.
export const toCountryId = (value?: string): string | undefined => {
  const needle = value?.trim();
  if (!needle) return undefined;
  if (countries.getLabel(needle)) return needle.toLowerCase();
  return countries.getValue(needle)?.toLowerCase();
};

// What a create payload sends for a picked site: a ConnectWise pick goes as
// crm-site-id (the API adopts it), a client pick as the client-location
// relationship. The API rejects both at once, and either on update.
export const siteLinkPayload = (picked: PickedRecord | null) => ({
  attributes: picked?.source === "crm" ? { "crm-site-id": picked.crmId } : {},
  relationships:
    picked?.source === "client"
      ? {
          "client-location": {
            data: { type: "client-locations" as const, id: picked.id },
          },
        }
      : {},
});
